import ProcessLogs from "./ProcessLogs";

export default ProcessLogs;
